import axios from "axios";
import store from "../../../redux/store";
import { setIsLoading } from "../../../redux/loader/action";
import { setCurrentUser } from "../../../redux/game/action";

const deleteSubTeam = async ({ team_code, sub_name }) => {
  const storeState = store.getStore().getState();
  const currentUser = storeState.gameReducer.currentUser;
  try {
    store.dispatch(setIsLoading(true));
    let url = process.env.REACT_APP_DELETE_SUBTEAM;
    const res = await axios.post(url, {
      team_code,
      sub_name,
    });
    store.dispatch(
      setCurrentUser({ ...currentUser, team: res.data.data || [] })
    );
    store.dispatch(setIsLoading(false));
  } catch (error) {
    store.dispatch(setIsLoading(false));
  }
};

export default deleteSubTeam;
